// Environment Configuration

const isProduction = (): boolean => {
  return (
    window.location.hostname === 'sorgenloskarte.flexxi.care' ||
    window.location.hostname === 'www.sorgenloskarte.flexxi.care'
  );
};

export const config = {
  apiUrl: isProduction() ? 'https://api.flexxi.care/' : 'https://api.flexxi.dev.swiftech.am/',

  stripeKey: isProduction()
    ? 'pk_live_WNFteFfeZYrWAzQGceSSmDXD'
    : 'pk_test_Uy4a9tomQRukBXm14a5VfgME',

  gtmId: 'GTM-5HH7TDV',

  isProduction: isProduction(),
};

export default config;
